// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/icons/menu-burger-btn.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "variables.css"; */

.navibar {
    height: 65px;
    background-color: #000;
    color: #fff;
    position: relative;
  }

/* .container {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
} */

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 100%;
  }
}

.navibar__brand {
  display: flex;
  padding: 0px;
}

.navibar__brand-img {
  height: 70px;
}

@media (max-width: 768px) {
  .navibar__brand {
    margin-left: 30px;
  } 
}

@media (min-width: 768px) {
  .navibar__brand {
    width: 50%;
  } 
}

.navibar-container {
    /* margin: 0 auto; */
    max-width: 1200px;
    /* background-color: green; */
    padding: 0;
}

.navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
  
.navbar-collapse {
  text-align: start;
  justify-content: flex-end;
}

.navbar-collapse.show {
  background-color: #000;
  /* padding-left: 10px; */
  position: absolute;
  /* top: 59px; */
  top: 65px;
  /* left: -12px; */
  z-index: 9999;

  width: 100%;
  text-align: center;
}

.dropdown-menu {
  --bs-dropdown-color: #fff;
  --bs-dropdown-bg: transparent;
  --bs-dropdown-border-radius: 0;
}

.dropdown-menu[data-bs-popper] {
  left: -5px;
  margin-top: 6px;
  padding-bottom: 0;
}

.dropdown-item {
  margin-bottom: 2px;
  background-color: #000;
  opacity: 0.8;
  color: #fff;
}

.dropdown-item:last-child {
  margin-bottom: 0;
}

.dropdown-item:focus, .dropdown-item:hover {
  /* color: #2bd191be; */
  color: var(--main-green-color);;
  background-color: #000;
  opacity: 1;
}

.dropdown-item a {
  text-decoration: none;
  color: inherit;
}

.nav-link a {
  color: inherit;
  text-decoration: none;
}

@media (max-width: 768px) {
  .navbar-collapse.show {
    background-color: transparent;
    /* width: 780px; */
  }
  .dropdown-menu.show {
    --bs-dropdown-color: #fff;
    --bs-dropdown-bg: #000;
    left: 135px;
    top: -15px;
    margin-top: 6px
  }

  .nav-item {
    background-color: #000;
    margin: 0 !important;
  }
  
    .nav-link {
    background-color: #000;
    opacity: 0.8;
    margin: 0 !important;
    padding: 5px 0px;
    margin-bottom: 2px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/navibar.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;IACI,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;;AAEF;;;;GAIG;;AAEH;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;EACE,yDAA+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,aAAa;;EAEb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV;EACF;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;IAEE;IACA,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,6BAA6B;EAC/B;AACF","sourcesContent":["/* @import \"variables.css\"; */\n\n.navibar {\n    height: 65px;\n    background-color: #000;\n    color: #fff;\n    position: relative;\n  }\n\n/* .container {\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n} */\n\n@media (min-width: 576px) {\n  .container, .container-sm {\n    max-width: 100%;\n  }\n}\n\n.navibar__brand {\n  display: flex;\n  padding: 0px;\n}\n\n.navibar__brand-img {\n  height: 70px;\n}\n\n@media (max-width: 768px) {\n  .navibar__brand {\n    margin-left: 30px;\n  } \n}\n\n@media (min-width: 768px) {\n  .navibar__brand {\n    width: 50%;\n  } \n}\n\n.navibar-container {\n    /* margin: 0 auto; */\n    max-width: 1200px;\n    /* background-color: green; */\n    padding: 0;\n}\n\n.navbar-toggler-icon {\n  background-image: url(/public/images/icons/menu-burger-btn.svg);\n}\n  \n.navbar-collapse {\n  text-align: start;\n  justify-content: flex-end;\n}\n\n.navbar-collapse.show {\n  background-color: #000;\n  /* padding-left: 10px; */\n  position: absolute;\n  /* top: 59px; */\n  top: 65px;\n  /* left: -12px; */\n  z-index: 9999;\n\n  width: 100%;\n  text-align: center;\n}\n\n.dropdown-menu {\n  --bs-dropdown-color: #fff;\n  --bs-dropdown-bg: transparent;\n  --bs-dropdown-border-radius: 0;\n}\n\n.dropdown-menu[data-bs-popper] {\n  left: -5px;\n  margin-top: 6px;\n  padding-bottom: 0;\n}\n\n.dropdown-item {\n  margin-bottom: 2px;\n  background-color: #000;\n  opacity: 0.8;\n  color: #fff;\n}\n\n.dropdown-item:last-child {\n  margin-bottom: 0;\n}\n\n.dropdown-item:focus, .dropdown-item:hover {\n  /* color: #2bd191be; */\n  color: var(--main-green-color);;\n  background-color: #000;\n  opacity: 1;\n}\n\n.dropdown-item a {\n  text-decoration: none;\n  color: inherit;\n}\n\n.nav-link a {\n  color: inherit;\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .navbar-collapse.show {\n    background-color: transparent;\n    /* width: 780px; */\n  }\n  .dropdown-menu.show {\n    --bs-dropdown-color: #fff;\n    --bs-dropdown-bg: #000;\n    left: 135px;\n    top: -15px;\n    margin-top: 6px\n  }\n\n  .nav-item {\n    background-color: #000;\n    margin: 0 !important;\n  }\n  \n    .nav-link {\n    background-color: #000;\n    opacity: 0.8;\n    margin: 0 !important;\n    padding: 5px 0px;\n    margin-bottom: 2px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
